import { ILockerProps } from "./Locker.props";
import { LockOutlined, UnlockOutlined } from "@ant-design/icons";
import styles from "./Locker.module.scss";
import cn from "classnames";
import { hexToRgb } from "@utils/hexToRgb";
import { useMemo } from "react";

export default function Locker({
  lock,
  green,
  className,
  color,

  onClick,
}: ILockerProps) {
  const currentColor = useMemo(() => {
    const primaryColor = "#0a28ab";
    const lightColor = "#fff";
    if (!color) return primaryColor;
    const parsed = hexToRgb(color);
    if (parsed) {
      return (parsed.rgb.r + parsed.rgb.g + parsed.rgb.b) / 3 > 150
        ? primaryColor
        : lightColor;
    }
    return primaryColor;
  }, [color]);

  return (
    <div className={cn(styles.wrapper, className)} onClick={(e) => onClick()}>
      {lock ? (
        <LockOutlined
          className={cn(styles.icon_lock, {
            [styles.green]: green,
          })}
          style={{ color: currentColor }}
          rev={undefined}
        />
      ) : (
        <UnlockOutlined
          className={styles.icon_unlock}
          style={{ color: currentColor }}
          rev={undefined}
        />
      )}
    </div>
  );
}
